import { render, staticRenderFns } from "./PaylasimAltYorum.vue?vue&type=template&id=7709fdc8&"
import script from "./PaylasimAltYorum.vue?vue&type=script&lang=js&"
export * from "./PaylasimAltYorum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports